<template>
    <div
        :aria-labelledby="title && bannerId"
        class="grid grid-cols-[min-content_1fr] items-start gap-x-2 rounded-lg border-2 p-3 text-content-primary"
        :class="`${variant}-banner`"
    >
        <div class="col-start-1 row-start-1 flex h-[1lh] items-center text-content-md">
            <DsIcon
                :icon="DS_ALERT_BANNER_VARIANT_ICONS[variant]"
                size="sm"
            />
        </div>
        <h6
            v-if="title"
            :id="bannerId"
            class="col-start-2 row-start-1 text-content-md font-semibold"
        >
            {{ title }}
        </h6>
        <div
            v-if="$slots.default"
            class="col-start-2 text-content-md"
            :class="title ? 'row-start-2 mt-1' : 'row-start-1'"
            data-testid="alert-banner-description"
        >
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';
import { useId } from 'vue';
import { DS_ALERT_BANNER_VARIANT_ICONS, type DsAlertBannerProps } from './alert-banner.types';

defineProps<DsAlertBannerProps>();

const bannerId = useId();
</script>

<style lang="scss" scoped>
.warning-banner {
    @apply border-ds-yellow-400 bg-ds-yellow-200;
}

.error-banner {
    @apply border-ds-red-600 bg-ds-red-200;
}

.info-banner {
    @apply border-ds-blue-400 bg-ds-blue-200;
}
</style>
